import React, { useRef, useState } from "react";
import axios from "axios";
import { MdUpload } from "react-icons/md";

import { bulkImportAPI } from "../../api/bulkImport.api";

const BulkImportButton = ({ module, label = "Import", onSuccess, companyId }) => {
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [alertData, setAlertData] = useState({
    type: "",
    message: "",
  });

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    if (companyId) {
      formData.append("company_id", companyId);
    }

     try {
      setLoading(true);

      const res = await bulkImportAPI(module, formData);

      const data = res.data;

      setAlertData({
        type: data.failed > 0 ? "warning" : "success",
        message: `${label} completed. Imported: ${data.imported}/${data.total}, Failed: ${data.failed}`,
      });

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      setAlertData({
        type: "error",
        message:
          error.response?.data?.message || `${label} failed. Please try again.`,
      });
    } finally {
      setLoading(false);
      e.target.value = null;
    }
  };

  return (
    <div>
      <button
        onClick={handleButtonClick}
        className="flex items-center gap-1 bg-brand-500 hover:bg-brand-600 text-white px-4 py-2 rounded-md text-sm font-medium"
      >
        <MdUpload className="text-lg" />
        {loading ? "Uploading..." : label}
         
      </button>

      <input
        type="file"
        accept=".csv"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />

      {result && (
        <div className="mt-4 p-3 bg-gray-100 rounded">
          <p>Total: {result.total}</p>
          <p>Imported: {result.imported}</p>
          <p>Failed: {result.failed}</p>
        </div>
      )}
    </div>
  );
};

export default BulkImportButton;
